import { render } from "./ProdOrderItem.vue?vue&type=template&id=c09021ce"
import script from "./ProdOrderItem.vue?vue&type=script&lang=js"
export * from "./ProdOrderItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__